import React from "react";
import AddCustomerModal from "features/Crm/modules/AddCustomerModal/components/AddCustomerModal";
import { BroadcastModal } from "common/Components/BroadcastModal/BroadcastModal";
import { ReconciliationModal } from "../../ReconciliationModal";
import { CustomerAttendanceForListingPopup } from "../../CustomerAttendanceForListingPopup";
import { LearnMorePopup } from "../../LearnMorePopup";
import { ZOOM_ATTENDANCE_CONSTANTS } from "../../../constants/ZoomAttendance.constants";
import { useSessionParticipantsContext } from "../context/SessionParticipantsContext";

export const SessionParticipantsModals = (props) => {
  const context = useSessionParticipantsContext();

  const {
    showBroadcastModal = context.showBroadcastModal,
    setShowBroadcastModal = context.setShowBroadcastModal,
    broadcastActions = context.broadcastActions,
    reconciliationModalProps = context.reconciliationModalProps || {},
    listingUuid = context.listingUuid,
    slotUuid = context.slotUuid,
    handleCloseReconcile = context.handleCloseReconcile,
    refetch = context.refetch,
    handleOpenCreateNewBooking = context.handleOpenCreateNewBooking,
    showAddCustomerModal = context.showAddCustomerModal,
    handleCloseAddCustomerModal = context.handleCloseAddCustomerModal,
    fullListingData = context.fullListingData,
    listingName = context.listingName,
    listingType = context.listingType,
    selectedParticipantForModal = context.selectedParticipantForModal,
    sessionDetails = context.sessionDetails,
    customerAttendancePopupProps = context.customerAttendancePopupProps || {},
    handleCloseCustomerAttendancePopup = context.handleCloseCustomerAttendancePopup,
    showLearnMorePopup = context.showLearnMorePopup,
    setShowLearnMorePopup = context.setShowLearnMorePopup,
  } = props;
  const getInitialValues = () => ({
    full_name:
      selectedParticipantForModal?.customer_name ||
      selectedParticipantForModal?.name ||
      "",
    email:
      selectedParticipantForModal?.customer_email ||
      selectedParticipantForModal?.user_email ||
      selectedParticipantForModal?.email ||
      "",
    phone:
      selectedParticipantForModal?.customer_phone ||
      selectedParticipantForModal?.customer_phone_numer ||
      "",
    selected_batch: slotUuid || "",
    slot_uuid: slotUuid || "",
    selected_appointment_slots: slotUuid
      ? [
          {
            date_index: ZOOM_ATTENDANCE_CONSTANTS.NUMERIC.ZERO,
            uuid: slotUuid,
            index: ZOOM_ATTENDANCE_CONSTANTS.NUMERIC.ZERO,
            time: sessionDetails?.start_time || "",
          },
        ]
      : [],
    map_zoom_attendance: true,
    participant_email:
      selectedParticipantForModal?.user_email ||
      selectedParticipantForModal?.customer_email ||
      selectedParticipantForModal?.email ||
      "",
    slot_uids: slotUuid ? [slotUuid] : [],
  });

  return (
    <>
      <BroadcastModal
        open={showBroadcastModal}
        onClose={() => setShowBroadcastModal(false)}
        modal_props={{
          title: ZOOM_ATTENDANCE_CONSTANTS.LABELS.SEND_MESSAGE_TITLE,
        }}
        mobile_modal_props={{
          header: ZOOM_ATTENDANCE_CONSTANTS.LABELS.SELECT_BROADCAST_MEDIUM,
        }}
        broadcastActions={broadcastActions}
      />

      {reconciliationModalProps.open && (
        <ReconciliationModal
          open={reconciliationModalProps.open}
          participant={reconciliationModalProps.participant}
          listingUuid={listingUuid}
          slotUuid={slotUuid}
          onClose={handleCloseReconcile}
          onReconcileSuccess={() => {
            if (refetch) refetch();
            window.location.reload();
          }}
          onCreateNewBooking={(participant) => {
            const currentPart =
              participant || reconciliationModalProps.participant;
            handleCloseReconcile();
            handleOpenCreateNewBooking(currentPart);
          }}
        />
      )}

      {showAddCustomerModal && (
        <AddCustomerModal
          open={showAddCustomerModal}
          onClose={handleCloseAddCustomerModal}
          listing_data={
            fullListingData || {
              uuid: listingUuid,
              title: listingName,
              type: listingType,
            }
          }
          disableOffering={Boolean(slotUuid)}
          disableAmount={Boolean(slotUuid)}
          initialValues={getInitialValues()}
          onSuccess={() => {
            handleCloseAddCustomerModal();
            if (refetch) refetch();
            window.location.reload();
          }}
        />
      )}

      {customerAttendancePopupProps.show && (
        <CustomerAttendanceForListingPopup
          open={customerAttendancePopupProps.show}
          customerData={customerAttendancePopupProps.customerData}
          listingUuid={listingUuid}
          listingName={listingName}
          onClose={handleCloseCustomerAttendancePopup}
        />
      )}

      {showLearnMorePopup && (
        <LearnMorePopup
          open={showLearnMorePopup}
          listingName={listingName}
          onClose={() => setShowLearnMorePopup(false)}
        />
      )}
    </>
  );
};
